import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=0ae39374&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=0ae39374&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports